import PropTypes from 'prop-types';
import clsx from 'clsx';
import Tooltip from '@/components/Tooltip';
import Input, { InputDefaultProps, InputPropTypes } from './Input';

export function ErrorSymbol({
  error,
}) {
  const content = (
    <button className="pointer absolute right-0 top-0 bottom-0 h-10 flex items-center px-3 text-red-400 hover:text-red-500 focus:outline-none" type="button">
      <svg className="w-5 h-5 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
      </svg>
    </button>
  );

  if (error === null || error === undefined) {
    return content;
  }

  return (
    <Tooltip tooltip={error}>
      {content}
    </Tooltip>
  );
}

const defaultProps = {
  ...InputDefaultProps,
  error: null,
  touched: false,
  hasError: false,
  light: true,
};

const propTypes = {
  ...InputPropTypes,
  error: PropTypes.string,
  touched: PropTypes.bool,
  hasError: PropTypes.bool,
  light: PropTypes.bool,
};

export default function Entry({
  type,
  className,
  disabled,
  error,
  touched,
  hasError,
  light,
  ...props
}) {
  const hasErrorFinal = hasError || (error !== null && touched === true);

  let finalClasses = ['border rounded-md focus:ring-2 focus:border-transparent focus:bg-white block w-full text-base h-10 px-3 focus:outline-none font-medium placeholder-gray-400'];

  if (light) {
    finalClasses = [
      ...finalClasses,
      'border-transparent',
      hasErrorFinal === false && 'bg-gray-100 focus:ring-green-500',
      hasErrorFinal === true && 'bg-red-50 focus:ring-red-500',
    ];
  } else {
    finalClasses = [
      ...finalClasses,
      'bg-white',
      'shadow-sm',
      hasErrorFinal === false && 'border-gray-400 bg-white focus:ring-green-500',
      hasErrorFinal === true && 'border-red-400 bg-red-50 focus:border-transparent focus:ring-red-500',
    ];
  }

  return (
    <div className="relative">
      <Input
        type={type}
        className={clsx(
          finalClasses,
          disabled === true && 'pointer-events-none opacity-70',
          className,
        )}
        disabled={disabled}
        {...props}
      />
    </div>
  );
}

Entry.defaultProps = defaultProps;
Entry.propTypes = propTypes;
